import { ROUTES } from '@/router/routeNames'

export default [
  {
    path: 'pages',
    children: [
      {
        name: ROUTES.PAGES,
        path: '',
        component: () => import('./pages/PagesIndex.vue'),
        meta: {
          title: 'Pages',
          description: 'Create and manage hosted landing pages and quiz funnels.'
        }
      },
      {
        name: ROUTES.PAGE_CREATE,
        path: 'new',
        component: () => import('./pages/PageCreate.vue'),
        meta: {
          title: 'New Page'
        }
      },
      {
        name: ROUTES.PAGE,
        path: ':pageId',
        component: () => import('./pages/PageShow.vue'),
        props: true,
        meta: {
          fullScreen: true
        }
      }
    ]
  }
]
